import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import JasonFile from "./formLangfields.json";
import { Dropdown } from "react-bootstrap";
import { Buffer } from 'buffer';
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import useRecorder from "../utils/useRecorder.js";
import { Microphone, Stop, SignOut, Pause, ArrowClockwise, Record, SpeakerHigh } from 'phosphor-react';
import mlj from "../helper/images/mlj.png";
import moe_logo from "../helper/images/moe_logo.png";
import anu_logo from "../helper/images/anuvadini_logo.png"
import { Loader, Placeholder } from 'rsuite';

function ListPage() {
  const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(false);
  const [searchQuery, setSearchQuery] = useState();
  const [selectLang, setLang] = useState('');
  const [recorderName, setRecorderName] = useState();
  const [audioURL, isRecording, startRecording, stopRecording, pause, setPause, resume, setResume, setIsRecording, setReset] = useRecorder();
  const [data, setData] = useState([]);
  const [IsLogin, setlegalIsLogin] = useState(false);
  const [feedback, setFeedback] = useState(false);
  const [audioSrc, setAudioSrc] = useState();
  const [buf, setBuf] = useState();
  const [play, SetPlay] = useState(false);
  const [prevAudio, setPrevAudio] = useState(null);
  const [resultView, SetResultView] = useState(true);
  const [searchKeys, SetSearchKeys] = useState([]);
  const [dataUpdate, SetDataUpdate] = useState(false);
  const [role, SetRole] = useState();
  const [isLoading, setIsLoading] = useState();

  const [inputList, setinputList] = useState([{
    ["_id"]: "",
    Act: [],
    keyword: "",
    Assamese_Value: "",
    Assamese_Value_verified: false,
    Assamese_Value_verified_at: "",
    Assamese_Value_verified_by: "",
    Assamese_Value_keywords: [],
    Bengali_Value: "",
    Bengali_Value_verified: false,
    Bengali_Value_verified_at: "",
    Bengali_Value_verified_by: "",
    Bengali_Value_keywords: [],
    Gujarati_Value: "",
    Gujarati_Value_verified: false,
    Gujarati_Value_verified_at: "",
    Gujarati_Value_verified_by: "",
    Gujarati_Value_keywords: [],
    Hindi_Value: "",
    Hindi_Value_verified: false,
    Hindi_Value_verified_at: "",
    Hindi_Value_verified_by: "",
    Hindi_Value_keywords: [],
    Kannada_Value: "",
    Kannada_Value_verified: false,
    Kannada_Value_verified_at: "",
    Kannada_Value_verified_by: "",
    Kannada_Value_keywords: [],
    Malayalam_Value: "",
    Malayalam_Value_verified: false,
    Malayalam_Value_verified_at: "",
    Malayalam_Value_verified_by: "",
    Malayalam_Value_keywords: [],
    Marathi_Value: "",
    Marathi_Value_verified: false,
    Marathi_Value_verified_at: "",
    Marathi_Value_verified_by: "",
    Marathi_Value_keywords: [],
    Oriya_Value: "",
    Oriya_Value_verified: false,
    Oriya_Value_verified_at: "",
    Oriya_Value_verified_by: "",
    Oriya_Value_keywords: [],
    Punjabi_Value: "",
    Punjabi_Value_verified: false,
    Punjabi_Value_verified_at: "",
    Punjabi_Value_verified_by: "",
    Punjabi_Value_keywords: [],
    Tamil_Value: "",
    Tamil_Value_verified: false,
    Tamil_Value_verified_at: "",
    Tamil_Value_verified_by: "",
    Tamil_Value_keywords: [],
    Telugu_Value: "",
    Telugu_Value_verified: false,
    Telugu_Value_verified_at: "",
    Telugu_Value_verified_by: "",
    Telugu_Value_keywords: [],
    Urdu_Value: "",
    Urdu_Value_verified: false,
    Urdu_Value_verified_at: "",
    Urdu_Value_verified_by: "",
    Word: "",
    category: "",
    isverify: false,
    original_language: ""
  }]);

  const handleLogout = () => {
    localStorage.removeItem("legalIsLogin");
    localStorage.removeItem("legaltoken");
    navigate("/lawdictionary");
  };
  const handleLogin = () => {
    navigate("/lawdictionary/login");
  };

  const handleSearchQuery = (event) => {
    let data = event.target.value;
    if (selectLang === 'en-IN' || selectLang === null) {
      let newd = data.replace(/[&\/\\#,+()$;~%^@_.'":*?<>{}]/g, '');
      if (newd == ' ') {
        setSearchQuery('');
      } else {
        setSearchQuery(newd)
        localStorage.setItem('legalsearchQuery', newd)
      }
    } else {
      localStorage.setItem('legalsearchQuery', data)
      setSearchQuery(data);
    }
  }

  useEffect(() => {
    const lang = localStorage.getItem("legalLanguage");
    const searchQuery = localStorage.getItem("legalsearchQuery");
    const legalIsLogin = localStorage.getItem("legalIsLogin");
    let isLogin = localStorage.getItem("legalIsLogin");
    setIsLogin(isLogin);
    setlegalIsLogin(legalIsLogin);
    setLang(lang);
    setSearchQuery(searchQuery);

    const token = localStorage.getItem("legaltoken");
    if (token) {
      const usrRole = jwt_decode(token).role
      SetRole(usrRole);
    }

    if (searchQuery != "" && selectLang != "") {
      let formData = { searchQuery: searchQuery, selectedLanguage: lang };
      axios
        .post(process.env.REACT_APP_BASE_URL + "find-glossary", formData)
        .then(function (response) {
          if (response.data.status == "success") {
            let data = response.data.response;
            let items = { ...inputList };
            items = data;
            setinputList(items);
            setFeedback(true);
            if (data.length == 1) {
              SetDataUpdate(!dataUpdate)
              setFeedback(true);
              setData(data[0]);
              SetResultView(false)
            }
            else {
              SetDataUpdate(!dataUpdate)
              SetResultView(true)
              SetSearchKeys(data);
              setIsLoading(false);
            }
          } else {
            setData({});
            setFeedback(false);
          }
        });
    }
  }, []);

  React.useEffect(() => {
    const fetchText = async () => {
      let fileName = `aud.wav`;
      let fd = new FormData();
      const output = await axios({ method: "get", url: audioURL, responseType: "blob" });
      let files = new File([output.data], fileName, { type: "audio/wav" });
      fd.append("file", files);
      fd.append("language", selectLang);
      axios.post("https://voiceapi.aicte-india.org/voice-to-text", fd)
        .then(async (res) => {
          const textResponse = res.data;
          let NewData = { ...inputList }
          if (recorderName == "searchQuery") {
            setSearchQuery(textResponse.data);
          }
          if (recorderName == "meaning") {
            NewData['keyword'] = textResponse.data;
            setinputList(NewData);
          }
          if (recorderName == "keyword") {
            NewData['keyword'] = textResponse.data;
            setinputList(NewData);
          }
        });
    };
    if (audioURL !== undefined) {
      fetchText();
    }
  }, [audioURL]);


  const handleForm = (e) => {
    const lang = localStorage.getItem("legalLanguage");
    const searchQuery = localStorage.getItem("legalsearchQuery");
    setIsLoading(true);
    let formData = { searchQuery: searchQuery, selectedLanguage: lang };
    SetSearchKeys([])
    axios
      .post(process.env.REACT_APP_BASE_URL + "find-glossary", formData)
      .then(function (response) {
        if (response.data.status == "success") {
          let data = response.data.response;
          let items = { ...inputList };
          items = data;
          setinputList(items);
          if (data.length == 1) {
            SetDataUpdate(!dataUpdate)
            setFeedback(true);
            SetResultView(false)
            setData(data[0]);
            setIsLoading(false);
          }
          else {
            SetDataUpdate(!dataUpdate)
            SetResultView(true)
            SetSearchKeys(data);
            setIsLoading(false);
          }
        } else {
          setData({});
          setFeedback(false);
          setIsLoading(false);
        }
      });
  };

  useEffect(() => {
    handleForm();
  }, [])

  useEffect(() => {
  }, [dataUpdate]);

  const HandleEditButton = (language) => {
    if (IsLogin == "true") {
      localStorage.setItem("editactData", JSON.stringify(inputList));
      localStorage.setItem("editlanguage", language);
      navigate("/lawdictionary/list/update");
    } else {
      navigate("/lawdictionary/login");
    };
  }

  const HandleAddButton = () => {
    navigate("/lawdictionary/add-new");
  }

  const getBuf = data => {
    return Buffer.from(data, "binary");
  }

  const handlePlay = (query, lang) => {
    let voice = JasonFile[3][lang];
    let Body = query;
    const post = { Body: Body, language: lang, voice: voice };
    axios.post('https://voiceapi.aicte-india.org/text-to-voice', post)
      .then(res => {
        const audioFile = getBuf(res.data.data.audio.data)
        let blob = new Blob([audioFile], { type: 'audio/wav' });
        setBuf(blob);
        let url = URL.createObjectURL(blob);
        setAudioSrc(url);
      });
  }

  useEffect(() => {
    if (prevAudio) {
      prevAudio.pause();
      prevAudio.currentTime = 0;
    }
    const aud = new Audio(audioSrc);
    aud.play();
    setPrevAudio(aud);
  }, [audioSrc])

  const keySelected = (it) => {
    setData(it)
    SetDataUpdate(!dataUpdate)
    SetResultView(false)
  }

  const actView = (data, key, audioLang) => {
    return data.map(item => {
      return (
        <>
          {item.Act_id ? <><strong>Act: </strong><p>{item.Act_id}</p></> : <></>}
          {item[key] ? <>
            <strong>Meaning: </strong>
            <p className="paraText">
              <p>{item[key]}</p>
              <SpeakerHigh size={20} onClick={(e) => { handlePlay(item[key], audioLang) }} className="w-auto mr-3" /></p></> : <></>}
        </>
      )
    })
  }

  const HandleReqApproval = () => {
    if (role === 'user') {
      navigate("/lawdictionary/user-request-list");
    } else {
      navigate("/lawdictionary/request-list");
    }
  }

  return (
    <>
      <div className="topDiv searchList">
        <header className="headerLst">
          <div className="container mainSrchDiv">
            <div className="mainSrchDivIn">
              <div className="row align-items-center">
                <div className="logoarea col-12 col-sm-12 col-md-12 col-lg-8">
                  <div className="d-flex justify-content-start flex-wrap align-items-center">
                    <div className="listLogo">
                      <a href="https://anuvadini.aicte-india.org/">
                        <img src={anu_logo} width="210px" />
                      </a>
                      <a >
                        <img src={mlj} alt="" width="200px" style={{ marginLeft: 10 }} />
                      </a>
                      <a href="">
                        <img src={moe_logo} alt="" style={{ marginLeft: 10, }} width="120px" />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                  <div className="d-flex justify-content-end align-items-center phonecenter">
                    <div className="d-flex justify-content-end flex-wrap buttonmargin">
                      <button className="feedbackSpn h-auto w-auto mr-3" style={{ height: 36, }} onClick={() => { navigate('/lawdictionary') }}>
                        Home
                      </button>
                      {feedback == false ? ("") : (
                        <>
                          <button className="feedbackSpn h-auto w-auto" style={{ height: 36, }} onClick={() => HandleAddButton()}>
                            Add New Record
                          </button>
                          {role == 'admin' ? <button className="feedbackSpn h-auto w-auto" style={{ marginLeft: '10px', marginTop: 5 }} onClick={() => { navigate('/lawdictionary/register-validator') }}>Create Validator Account</button> : <></>}
                        </>
                      )}
                    </div>
                    <div className="d-flex flex-wrap justify-content-end">
                      <button className="feedbackSpn h-auto w-auto" style={{ marginLeft: '10px', }} onClick={() => { navigate('/lawdictionary/home') }}>A to Z Words</button>
                      {isLogin == "true" ? <>
                        <button className="feedbackSpn h-auto w-auto mr-3" style={{ height: 36, marginLeft: "10px", }} onClick={() => HandleReqApproval()}>
                          Approval Requests
                        </button>
                      </> : <></>}
                    </div>
                    {isLogin == "true" ? (
                      <>
                        <div className="d-flex justify-content-end buttonmargin">
                          <div className="wrapper signout">
                            <button className="button w-auto" onClick={() => handleLogout()}><b><SignOut size={32} /></b>
                            </button>
                          </div>
                        </div>
                      </>) : (<>
                        <div className="wrapper listLogin">
                          <button className="button w-auto" onClick={() => handleLogin()} > <b>Login</b></button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-md-12 col-xs-12 formSrchDivLst">
                <div className="formSrchDiv" style={{ display: "flex" }}>
                  <span className="slctLang">
                    <Dropdown className="text-end">
                      <Dropdown.Toggle className="selectmenu text-start p-relative w-auto" variant="success">
                        {selectLang ? JasonFile[0][selectLang] : "Select Language"}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {Object.entries(JasonFile[0]).map((res, i) => {
                          return (
                            <Dropdown.Item value={res[0]} onClick={(e) => { setLang(res[0]); localStorage.setItem("legalLanguage", res[0]); }} key={i} >
                              {res[1]}
                            </Dropdown.Item>
                          );
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  </span>
                  <div className="formInputTxt">
                    <input type="text" name="searchQuery" className="form-conrol form-control-home" placeholder="Search" value={searchQuery} onChange={(event) => handleSearchQuery(event)} />
                    <span className="frmSrchIcn">
                      <i className="fa fa-search" aria-hidden="true"></i>
                    </span>
                    {selectLang === "or-IN" || selectLang === "as-IN" || selectLang === "pa-IN" ? <></> : <>
                      <div className="fromGroup scheme new">
                        {isRecording && recorderName == "searchQuery" ? (
                          <React.Fragment>
                            <button className="stopbutton startbutton" onClick={stopRecording} disabled={!isRecording} >
                              <Stop size={20} weight="fill" />
                            </button>
                            {pause != false ? (
                              <>
                                <button className="stopbutton startbutton" onClick={() => { setPause(false); setResume(true); }} >
                                  <Record size={20} weight="fill" />
                                </button>
                                <button className="stopbutton startbutton" onClick={() => { }} disabled={!isRecording} >
                                  <ArrowClockwise size={20} weight="bold" />
                                </button>
                              </>
                            ) : (
                              <>
                                <button className="stopbutton startbutton" onClick={() => { setPause(true); }} >
                                  <Pause size={20} weight="fill" />
                                </button>
                                {Text ? (
                                  <button className="stopbutton startbutton" onClick={() => { }} disabled={!isRecording} >
                                    <ArrowClockwise size={20} />
                                  </button>
                                ) : ("")}
                              </>
                            )}
                          </React.Fragment>
                        ) : (
                          <button className="startbutton" onClick={(e) => { setRecorderName("searchQuery"); startRecording(); }} disabled={isRecording} >
                            <Microphone size={20} weight="fill" />
                          </button>
                        )}
                      </div>
                    </>}
                  </div>

                  <div className="sbmtBtnDiv">
                    <button type="submit" className="srchBtnHm" onClick={() => handleForm()} >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>

        {!resultView ?
          <section className="searchListSec">
            <div className="container-fluid">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h1>Searched keyword: {searchQuery}</h1>
                <h1 className="categoris">Category: {data.category}</h1>
              </div>
              <div className="d-flex justify-content-between align-items-center mb-4">

              </div>


              <div className="srchListOne _l3">
                <div className="srchOntBtm">
                  <div className="srchOneTp">
                    <div className="srchOneTpIcn">
                      <span>{JasonFile[7][selectLang]}</span>
                    </div>
                    <div className="text-end verified">
                      <span style={{ color: "green", fontSize: 14, display: "flex" }}> {data[JasonFile[4][selectLang]] && data[JasonFile[4][selectLang]] == true ? <>
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#008000" viewBox="0 0 256 256">
                          <path d="M224.42,104.2c-3.9-4.07-7.93-8.27-9.55-12.18-1.5-3.63-1.58-9-1.67-14.68-.14-9.38-.3-20-7.42-27.12S188,42.94,178.66,42.8c-5.68-.09-11-.17-14.68-1.67-3.91-1.62-8.11-5.65-12.18-9.55C145.16,25.22,137.64,18,128,18s-17.16,7.22-23.8,13.58c-4.07,3.9-8.27,7.93-12.18,9.55-3.63,1.5-9,1.58-14.68,1.67-9.38.14-20,.3-27.12,7.42S42.94,68,42.8,77.34c-.09,5.68-.17,11-1.67,14.68-1.62,3.91-5.65,8.11-9.55,12.18C25.22,110.84,18,118.36,18,128s7.22,17.16,13.58,23.8c3.9,4.07,7.93,8.27,9.55,12.18,1.5,3.63,1.58,9,1.67,14.68.14,9.38.3,20,7.42,27.12S68,213.06,77.34,213.2c5.68.09,11,.17,14.68,1.67,3.91,1.62,8.11,5.65,12.18,9.55C110.84,230.78,118.36,238,128,238s17.16-7.22,23.8-13.58c4.07-3.9,8.27-7.93,12.18-9.55,3.63-1.5,9-1.58,14.68-1.67,9.38-.14,20-.3,27.12-7.42s7.28-17.74,7.42-27.12c.09-5.68.17-11,1.67-14.68,1.62-3.91,5.65-8.11,9.55-12.18C230.78,145.16,238,137.64,238,128S230.78,110.84,224.42,104.2Zm-8.66,39.3c-4.67,4.86-9.5,9.9-12,15.9-2.38,5.74-2.48,12.52-2.58,19.08-.11,7.44-.23,15.14-3.9,18.82s-11.38,3.79-18.82,3.9c-6.56.1-13.34.2-19.08,2.58-6,2.48-11,7.31-15.91,12-5.25,5-10.68,10.24-15.49,10.24s-10.24-5.21-15.5-10.24c-4.86-4.67-9.9-9.5-15.9-12-5.74-2.38-12.52-2.48-19.08-2.58-7.44-.11-15.14-.23-18.82-3.9s-3.79-11.38-3.9-18.82c-.1-6.56-.2-13.34-2.58-19.08-2.48-6-7.31-11-12-15.91C35.21,138.24,30,132.81,30,128s5.21-10.24,10.24-15.5c4.67-4.86,9.5-9.9,12-15.9,2.38-5.74,2.48-12.52,2.58-19.08.11-7.44.23-15.14,3.9-18.82s11.38-3.79,18.82-3.9c6.56-.1,13.34-.2,19.08-2.58,6-2.48,11-7.31,15.91-12C117.76,35.21,123.19,30,128,30s10.24,5.21,15.5,10.24c4.86,4.67,9.9,9.5,15.9,12,5.74,2.38,12.52,2.48,19.08,2.58,7.44.11,15.14.23,18.82,3.9s3.79,11.38,3.9,18.82c.1,6.56.2,13.34,2.58,19.08,2.48,6,7.31,11,12,15.91,5,5.25,10.24,10.68,10.24,15.49S220.79,138.24,215.76,143.5ZM172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76Z">
                          </path>
                        </svg>
                        <p>Verified by law professional</p></> : ""}
                      </span>
                    </div>
                    <button className="feedbackSpn h-auto w-auto" style={{ height: 38 }} onClick={() => HandleEditButton(selectLang)} >
                      Edit Record
                    </button>
                    <div className="srchOneRgt">
                      <h4 className="srchFrHdng">
                        <strong>{data[JasonFile[1][selectLang]]}</strong>

                        <div className='speekers'>
                          {data[JasonFile[1][selectLang]] ? <>
                            <SpeakerHigh size={20} onClick={(e) => { handlePlay(data[JasonFile[1][selectLang]], selectLang) }} className="w-auto mr-3" />
                          </> : <></>}
                        </div>
                      </h4>
                    </div>
                  </div>
                  <div className="newtext">
                    <h3>
                      {actView(inputList[0].Act, JasonFile[2][selectLang], selectLang)}
                    </h3>
                    <h5>Keywords : {data[JasonFile[6][selectLang]].join(', ')}</h5>
                  </div>
                </div>
              </div>


              {selectLang !== 'hi-IN' ? <>
                <div className="srchListOne _l3">
                  <div className="srchOntBtm">
                    <div className="srchOneTp">
                      <div className="srchOneTpIcn">
                        <span>हिंदी</span>
                      </div>
                      <div className="text-end verified">
                        <span style={{ color: "green", fontSize: 14, display: "flex" }}> {data.Hindi_Value_verified == true ? <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#008000" viewBox="0 0 256 256">
                            <path d="M224.42,104.2c-3.9-4.07-7.93-8.27-9.55-12.18-1.5-3.63-1.58-9-1.67-14.68-.14-9.38-.3-20-7.42-27.12S188,42.94,178.66,42.8c-5.68-.09-11-.17-14.68-1.67-3.91-1.62-8.11-5.65-12.18-9.55C145.16,25.22,137.64,18,128,18s-17.16,7.22-23.8,13.58c-4.07,3.9-8.27,7.93-12.18,9.55-3.63,1.5-9,1.58-14.68,1.67-9.38.14-20,.3-27.12,7.42S42.94,68,42.8,77.34c-.09,5.68-.17,11-1.67,14.68-1.62,3.91-5.65,8.11-9.55,12.18C25.22,110.84,18,118.36,18,128s7.22,17.16,13.58,23.8c3.9,4.07,7.93,8.27,9.55,12.18,1.5,3.63,1.58,9,1.67,14.68.14,9.38.3,20,7.42,27.12S68,213.06,77.34,213.2c5.68.09,11,.17,14.68,1.67,3.91,1.62,8.11,5.65,12.18,9.55C110.84,230.78,118.36,238,128,238s17.16-7.22,23.8-13.58c4.07-3.9,8.27-7.93,12.18-9.55,3.63-1.5,9-1.58,14.68-1.67,9.38-.14,20-.3,27.12-7.42s7.28-17.74,7.42-27.12c.09-5.68.17-11,1.67-14.68,1.62-3.91,5.65-8.11,9.55-12.18C230.78,145.16,238,137.64,238,128S230.78,110.84,224.42,104.2Zm-8.66,39.3c-4.67,4.86-9.5,9.9-12,15.9-2.38,5.74-2.48,12.52-2.58,19.08-.11,7.44-.23,15.14-3.9,18.82s-11.38,3.79-18.82,3.9c-6.56.1-13.34.2-19.08,2.58-6,2.48-11,7.31-15.91,12-5.25,5-10.68,10.24-15.49,10.24s-10.24-5.21-15.5-10.24c-4.86-4.67-9.9-9.5-15.9-12-5.74-2.38-12.52-2.48-19.08-2.58-7.44-.11-15.14-.23-18.82-3.9s-3.79-11.38-3.9-18.82c-.1-6.56-.2-13.34-2.58-19.08-2.48-6-7.31-11-12-15.91C35.21,138.24,30,132.81,30,128s5.21-10.24,10.24-15.5c4.67-4.86,9.5-9.9,12-15.9,2.38-5.74,2.48-12.52,2.58-19.08.11-7.44.23-15.14,3.9-18.82s11.38-3.79,18.82-3.9c6.56-.1,13.34-.2,19.08-2.58,6-2.48,11-7.31,15.91-12C117.76,35.21,123.19,30,128,30s10.24,5.21,15.5,10.24c4.86,4.67,9.9,9.5,15.9,12,5.74,2.38,12.52,2.48,19.08,2.58,7.44.11,15.14.23,18.82,3.9s3.79,11.38,3.9,18.82c.1,6.56.2,13.34,2.58,19.08,2.48,6,7.31,11,12,15.91,5,5.25,10.24,10.68,10.24,15.49S220.79,138.24,215.76,143.5ZM172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76Z">
                            </path>
                          </svg>
                          <p>Verified by law professional</p></> : ""}
                        </span>
                      </div>
                      <button className="feedbackSpn h-auto w-auto" style={{ height: 38 }} onClick={() => HandleEditButton('hi-IN')} >
                        Edit Record
                      </button>
                      <div className="srchOneRgt">
                        <h4 className="srchFrHdng">
                          <strong>{data.Hindi_Value}</strong>
                          <div className='speekers'>
                            {data?.Hindi_Value ? <>
                              <SpeakerHigh size={20} onClick={(e) => { handlePlay(data?.Hindi_Value, 'hi-IN') }} className="w-auto mr-3" />
                            </> : <></>}
                          </div>
                        </h4>
                      </div>
                    </div>
                    <div className="newtext">
                      <h3>
                        {actView(inputList[0].Act, 'Hindi_Meaning', "hi-IN")}
                      </h3>
                      <h5>Keywords : {data.Hindi_Value_keywords.join(', ')}</h5>
                    </div>
                  </div>
                </div>
              </> : <></>}

              {selectLang !== 'en-IN' ? <>
                <div className="srchListOne _l1">
                  <div className="srchOntBtm">
                    <div className="srchOneTp">
                      <div className="srchOneTpIcn">
                        <span>English</span>
                      </div>
                      <div className="text-end verified">
                        <span style={{ color: "green", fontSize: 14, display: "flex" }}> {data.English_Value_verified == true ? <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#008000" viewBox="0 0 256 256">
                            <path d="M224.42,104.2c-3.9-4.07-7.93-8.27-9.55-12.18-1.5-3.63-1.58-9-1.67-14.68-.14-9.38-.3-20-7.42-27.12S188,42.94,178.66,42.8c-5.68-.09-11-.17-14.68-1.67-3.91-1.62-8.11-5.65-12.18-9.55C145.16,25.22,137.64,18,128,18s-17.16,7.22-23.8,13.58c-4.07,3.9-8.27,7.93-12.18,9.55-3.63,1.5-9,1.58-14.68,1.67-9.38.14-20,.3-27.12,7.42S42.94,68,42.8,77.34c-.09,5.68-.17,11-1.67,14.68-1.62,3.91-5.65,8.11-9.55,12.18C25.22,110.84,18,118.36,18,128s7.22,17.16,13.58,23.8c3.9,4.07,7.93,8.27,9.55,12.18,1.5,3.63,1.58,9,1.67,14.68.14,9.38.3,20,7.42,27.12S68,213.06,77.34,213.2c5.68.09,11,.17,14.68,1.67,3.91,1.62,8.11,5.65,12.18,9.55C110.84,230.78,118.36,238,128,238s17.16-7.22,23.8-13.58c4.07-3.9,8.27-7.93,12.18-9.55,3.63-1.5,9-1.58,14.68-1.67,9.38-.14,20-.3,27.12-7.42s7.28-17.74,7.42-27.12c.09-5.68.17-11,1.67-14.68,1.62-3.91,5.65-8.11,9.55-12.18C230.78,145.16,238,137.64,238,128S230.78,110.84,224.42,104.2Zm-8.66,39.3c-4.67,4.86-9.5,9.9-12,15.9-2.38,5.74-2.48,12.52-2.58,19.08-.11,7.44-.23,15.14-3.9,18.82s-11.38,3.79-18.82,3.9c-6.56.1-13.34.2-19.08,2.58-6,2.48-11,7.31-15.91,12-5.25,5-10.68,10.24-15.49,10.24s-10.24-5.21-15.5-10.24c-4.86-4.67-9.9-9.5-15.9-12-5.74-2.38-12.52-2.48-19.08-2.58-7.44-.11-15.14-.23-18.82-3.9s-3.79-11.38-3.9-18.82c-.1-6.56-.2-13.34-2.58-19.08-2.48-6-7.31-11-12-15.91C35.21,138.24,30,132.81,30,128s5.21-10.24,10.24-15.5c4.67-4.86,9.5-9.9,12-15.9,2.38-5.74,2.48-12.52,2.58-19.08.11-7.44.23-15.14,3.9-18.82s11.38-3.79,18.82-3.9c6.56-.1,13.34-.2,19.08-2.58,6-2.48,11-7.31,15.91-12C117.76,35.21,123.19,30,128,30s10.24,5.21,15.5,10.24c4.86,4.67,9.9,9.5,15.9,12,5.74,2.38,12.52,2.48,19.08,2.58,7.44.11,15.14.23,18.82,3.9s3.79,11.38,3.9,18.82c.1,6.56.2,13.34,2.58,19.08,2.48,6,7.31,11,12,15.91,5,5.25,10.24,10.68,10.24,15.49S220.79,138.24,215.76,143.5ZM172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76Z">
                            </path>
                          </svg>
                          <p>Verified by law professional</p></> : ""}
                        </span>
                      </div>
                      <button className="feedbackSpn h-auto w-auto" style={{ height: 38 }} onClick={() => HandleEditButton('en-IN')} >
                        Edit Record
                      </button>
                      <div className="srchOneRgt">
                        <h4 className="srchFrHdng">
                          <strong>{data?.English_Value}</strong>
                          <div className='speekers'>
                            {data?.English_Value ? <>
                              <SpeakerHigh size={20} onClick={(e) => { handlePlay(data?.English_Value, 'en-IN') }} className="w-auto mr-3" />
                            </> : <></>}
                          </div>
                        </h4>
                      </div>
                    </div>
                    <div className="newtext">
                      <h3>
                        {actView(inputList[0].Act, 'English_Meaning', "en-IN")}
                      </h3>
                      <h5>Keywords : {data.English_Value_keywords.join(', ')}</h5>
                    </div>
                  </div>
                </div>
              </> : <></>}
              {selectLang !== 'te-IN' ? <>
                <div className="srchListOne _l2">
                  <div className="srchOntBtm">
                    <div className="srchOneTp">
                      <div className="srchOneTpIcn">
                        <span>తెలుగు</span>
                      </div>
                      <div className="text-end verified">
                        <span style={{ color: "green", fontSize: 14, display: "flex" }}> {data.Telugu_Value_verified == true ? <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#008000" viewBox="0 0 256 256">
                            <path d="M224.42,104.2c-3.9-4.07-7.93-8.27-9.55-12.18-1.5-3.63-1.58-9-1.67-14.68-.14-9.38-.3-20-7.42-27.12S188,42.94,178.66,42.8c-5.68-.09-11-.17-14.68-1.67-3.91-1.62-8.11-5.65-12.18-9.55C145.16,25.22,137.64,18,128,18s-17.16,7.22-23.8,13.58c-4.07,3.9-8.27,7.93-12.18,9.55-3.63,1.5-9,1.58-14.68,1.67-9.38.14-20,.3-27.12,7.42S42.94,68,42.8,77.34c-.09,5.68-.17,11-1.67,14.68-1.62,3.91-5.65,8.11-9.55,12.18C25.22,110.84,18,118.36,18,128s7.22,17.16,13.58,23.8c3.9,4.07,7.93,8.27,9.55,12.18,1.5,3.63,1.58,9,1.67,14.68.14,9.38.3,20,7.42,27.12S68,213.06,77.34,213.2c5.68.09,11,.17,14.68,1.67,3.91,1.62,8.11,5.65,12.18,9.55C110.84,230.78,118.36,238,128,238s17.16-7.22,23.8-13.58c4.07-3.9,8.27-7.93,12.18-9.55,3.63-1.5,9-1.58,14.68-1.67,9.38-.14,20-.3,27.12-7.42s7.28-17.74,7.42-27.12c.09-5.68.17-11,1.67-14.68,1.62-3.91,5.65-8.11,9.55-12.18C230.78,145.16,238,137.64,238,128S230.78,110.84,224.42,104.2Zm-8.66,39.3c-4.67,4.86-9.5,9.9-12,15.9-2.38,5.74-2.48,12.52-2.58,19.08-.11,7.44-.23,15.14-3.9,18.82s-11.38,3.79-18.82,3.9c-6.56.1-13.34.2-19.08,2.58-6,2.48-11,7.31-15.91,12-5.25,5-10.68,10.24-15.49,10.24s-10.24-5.21-15.5-10.24c-4.86-4.67-9.9-9.5-15.9-12-5.74-2.38-12.52-2.48-19.08-2.58-7.44-.11-15.14-.23-18.82-3.9s-3.79-11.38-3.9-18.82c-.1-6.56-.2-13.34-2.58-19.08-2.48-6-7.31-11-12-15.91C35.21,138.24,30,132.81,30,128s5.21-10.24,10.24-15.5c4.67-4.86,9.5-9.9,12-15.9,2.38-5.74,2.48-12.52,2.58-19.08.11-7.44.23-15.14,3.9-18.82s11.38-3.79,18.82-3.9c6.56-.1,13.34-.2,19.08-2.58,6-2.48,11-7.31,15.91-12C117.76,35.21,123.19,30,128,30s10.24,5.21,15.5,10.24c4.86,4.67,9.9,9.5,15.9,12,5.74,2.38,12.52,2.48,19.08,2.58,7.44.11,15.14.23,18.82,3.9s3.79,11.38,3.9,18.82c.1,6.56.2,13.34,2.58,19.08,2.48,6,7.31,11,12,15.91,5,5.25,10.24,10.68,10.24,15.49S220.79,138.24,215.76,143.5ZM172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76Z">
                            </path>
                          </svg>
                          <p>Verified by law professional</p></> : ""}
                        </span>
                      </div>
                      <button className="feedbackSpn h-auto w-auto" style={{ height: 38 }} onClick={() => HandleEditButton('te-IN')} >
                        Edit Record
                      </button>
                      <div className="srchOneRgt">
                        <h4 className="srchFrHdng">
                          <strong>{data?.Telugu_Value}</strong>
                          <div className='speekers'>
                            {data?.Telugu_Value ? <>
                              <SpeakerHigh size={20} onClick={(e) => { handlePlay(data?.Telugu_Value, 'te-IN') }} className="w-auto mr-3" />
                            </> : <></>}
                          </div>
                        </h4>
                      </div>
                    </div>
                    <div className="newtext">
                      <h3>
                        {actView(inputList[0].Act, 'Telugu_Meaning', "te-IN")}
                      </h3>
                      <h5>Keywords : {data.Telugu_Value_keywords.join(', ')}</h5>
                    </div>
                  </div>
                </div>
              </> : <></>}

              {selectLang !== 'ta-IN' ? <>
                <div className="srchListOne _l3">
                  <div className="srchOntBtm">
                    <div className="srchOneTp">
                      <div className="srchOneTpIcn">
                        <span>தமிழ்</span>
                      </div>
                      <div className="text-end verified">
                        <span style={{ color: "green", fontSize: 14, display: "flex" }}> {data.Tamil_Value_verified == true ? <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#008000" viewBox="0 0 256 256">
                            <path d="M224.42,104.2c-3.9-4.07-7.93-8.27-9.55-12.18-1.5-3.63-1.58-9-1.67-14.68-.14-9.38-.3-20-7.42-27.12S188,42.94,178.66,42.8c-5.68-.09-11-.17-14.68-1.67-3.91-1.62-8.11-5.65-12.18-9.55C145.16,25.22,137.64,18,128,18s-17.16,7.22-23.8,13.58c-4.07,3.9-8.27,7.93-12.18,9.55-3.63,1.5-9,1.58-14.68,1.67-9.38.14-20,.3-27.12,7.42S42.94,68,42.8,77.34c-.09,5.68-.17,11-1.67,14.68-1.62,3.91-5.65,8.11-9.55,12.18C25.22,110.84,18,118.36,18,128s7.22,17.16,13.58,23.8c3.9,4.07,7.93,8.27,9.55,12.18,1.5,3.63,1.58,9,1.67,14.68.14,9.38.3,20,7.42,27.12S68,213.06,77.34,213.2c5.68.09,11,.17,14.68,1.67,3.91,1.62,8.11,5.65,12.18,9.55C110.84,230.78,118.36,238,128,238s17.16-7.22,23.8-13.58c4.07-3.9,8.27-7.93,12.18-9.55,3.63-1.5,9-1.58,14.68-1.67,9.38-.14,20-.3,27.12-7.42s7.28-17.74,7.42-27.12c.09-5.68.17-11,1.67-14.68,1.62-3.91,5.65-8.11,9.55-12.18C230.78,145.16,238,137.64,238,128S230.78,110.84,224.42,104.2Zm-8.66,39.3c-4.67,4.86-9.5,9.9-12,15.9-2.38,5.74-2.48,12.52-2.58,19.08-.11,7.44-.23,15.14-3.9,18.82s-11.38,3.79-18.82,3.9c-6.56.1-13.34.2-19.08,2.58-6,2.48-11,7.31-15.91,12-5.25,5-10.68,10.24-15.49,10.24s-10.24-5.21-15.5-10.24c-4.86-4.67-9.9-9.5-15.9-12-5.74-2.38-12.52-2.48-19.08-2.58-7.44-.11-15.14-.23-18.82-3.9s-3.79-11.38-3.9-18.82c-.1-6.56-.2-13.34-2.58-19.08-2.48-6-7.31-11-12-15.91C35.21,138.24,30,132.81,30,128s5.21-10.24,10.24-15.5c4.67-4.86,9.5-9.9,12-15.9,2.38-5.74,2.48-12.52,2.58-19.08.11-7.44.23-15.14,3.9-18.82s11.38-3.79,18.82-3.9c6.56-.1,13.34-.2,19.08-2.58,6-2.48,11-7.31,15.91-12C117.76,35.21,123.19,30,128,30s10.24,5.21,15.5,10.24c4.86,4.67,9.9,9.5,15.9,12,5.74,2.38,12.52,2.48,19.08,2.58,7.44.11,15.14.23,18.82,3.9s3.79,11.38,3.9,18.82c.1,6.56.2,13.34,2.58,19.08,2.48,6,7.31,11,12,15.91,5,5.25,10.24,10.68,10.24,15.49S220.79,138.24,215.76,143.5ZM172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76Z">
                            </path>
                          </svg>
                          <p>Verified by law professional</p></> : ""}
                        </span>
                      </div>
                      <button className="feedbackSpn h-auto w-auto" style={{ height: 38 }} onClick={() => HandleEditButton('ta-IN')} >
                        Edit Record
                      </button>
                      <div className="srchOneRgt">
                        <h4 className="srchFrHdng">
                          <strong>{data?.Tamil_Value}</strong>
                          <div className='speekers'>
                            {data?.Tamil_Value ? <>
                              <SpeakerHigh size={20} onClick={(e) => { handlePlay(data?.Tamil_Value, 'ta-IN') }} className="w-auto mr-3" />
                            </> : <></>}
                          </div>
                        </h4>
                      </div>
                    </div>
                    <div className="newtext">
                      <h3>
                        {actView(inputList[0].Act, 'Tamil_Meaning', "ta-IN")}
                      </h3>
                      <h5>Keywords : {data.Tamil_Value_keywords.join(', ')}</h5>
                    </div>
                  </div>
                </div>
              </> : <></>}
              {selectLang !== 'kn-IN' ? <>
                <div className="srchListOne _l2">
                  <div className="srchOntBtm">
                    <div className="srchOneTp">
                      <div className="srchOneTpIcn">
                        <span>ಕನ್ನಡ</span>
                      </div>
                      <div className="text-end verified">
                        <span style={{ color: "green", fontSize: 14, display: "flex" }}> {data.Kannada_Value_verified == true ? <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#008000" viewBox="0 0 256 256">
                            <path d="M224.42,104.2c-3.9-4.07-7.93-8.27-9.55-12.18-1.5-3.63-1.58-9-1.67-14.68-.14-9.38-.3-20-7.42-27.12S188,42.94,178.66,42.8c-5.68-.09-11-.17-14.68-1.67-3.91-1.62-8.11-5.65-12.18-9.55C145.16,25.22,137.64,18,128,18s-17.16,7.22-23.8,13.58c-4.07,3.9-8.27,7.93-12.18,9.55-3.63,1.5-9,1.58-14.68,1.67-9.38.14-20,.3-27.12,7.42S42.94,68,42.8,77.34c-.09,5.68-.17,11-1.67,14.68-1.62,3.91-5.65,8.11-9.55,12.18C25.22,110.84,18,118.36,18,128s7.22,17.16,13.58,23.8c3.9,4.07,7.93,8.27,9.55,12.18,1.5,3.63,1.58,9,1.67,14.68.14,9.38.3,20,7.42,27.12S68,213.06,77.34,213.2c5.68.09,11,.17,14.68,1.67,3.91,1.62,8.11,5.65,12.18,9.55C110.84,230.78,118.36,238,128,238s17.16-7.22,23.8-13.58c4.07-3.9,8.27-7.93,12.18-9.55,3.63-1.5,9-1.58,14.68-1.67,9.38-.14,20-.3,27.12-7.42s7.28-17.74,7.42-27.12c.09-5.68.17-11,1.67-14.68,1.62-3.91,5.65-8.11,9.55-12.18C230.78,145.16,238,137.64,238,128S230.78,110.84,224.42,104.2Zm-8.66,39.3c-4.67,4.86-9.5,9.9-12,15.9-2.38,5.74-2.48,12.52-2.58,19.08-.11,7.44-.23,15.14-3.9,18.82s-11.38,3.79-18.82,3.9c-6.56.1-13.34.2-19.08,2.58-6,2.48-11,7.31-15.91,12-5.25,5-10.68,10.24-15.49,10.24s-10.24-5.21-15.5-10.24c-4.86-4.67-9.9-9.5-15.9-12-5.74-2.38-12.52-2.48-19.08-2.58-7.44-.11-15.14-.23-18.82-3.9s-3.79-11.38-3.9-18.82c-.1-6.56-.2-13.34-2.58-19.08-2.48-6-7.31-11-12-15.91C35.21,138.24,30,132.81,30,128s5.21-10.24,10.24-15.5c4.67-4.86,9.5-9.9,12-15.9,2.38-5.74,2.48-12.52,2.58-19.08.11-7.44.23-15.14,3.9-18.82s11.38-3.79,18.82-3.9c6.56-.1,13.34-.2,19.08-2.58,6-2.48,11-7.31,15.91-12C117.76,35.21,123.19,30,128,30s10.24,5.21,15.5,10.24c4.86,4.67,9.9,9.5,15.9,12,5.74,2.38,12.52,2.48,19.08,2.58,7.44.11,15.14.23,18.82,3.9s3.79,11.38,3.9,18.82c.1,6.56.2,13.34,2.58,19.08,2.48,6,7.31,11,12,15.91,5,5.25,10.24,10.68,10.24,15.49S220.79,138.24,215.76,143.5ZM172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76Z">
                            </path>
                          </svg>
                          <p>Verified by law professional</p></> : ""}
                        </span>
                      </div>
                      <button className="feedbackSpn h-auto w-auto" style={{ height: 38 }} onClick={() => HandleEditButton('kn-IN')} >
                        Edit Record
                      </button>
                      <div className="srchOneRgt">
                        <h4 className="srchFrHdng">
                          <strong>{data?.Kannada_Value}</strong>
                          <div className='speekers'>
                            {data?.Kannada_Value ? <>
                              <SpeakerHigh size={20} onClick={(e) => { handlePlay(data?.Kannada_Value, 'kn-IN') }} className="w-auto mr-3" />
                            </> : <></>}
                          </div>
                        </h4>
                      </div>
                    </div>
                    <div className="newtext">
                      <h3>
                        {actView(inputList[0].Act, 'Kannada_Meaning', "kn-IN")}
                      </h3>
                      <h5>Keywords : {data.Kannada_Value_keywords.join(', ')}</h5>
                    </div>
                  </div>
                </div>
              </> : <></>}

              {selectLang !== 'ml-IN' ? <>
                <div className="srchListOne _l1">
                  <div className="srchOntBtm">
                    <div className="srchOneTp">
                      <div className="srchOneTpIcn">
                        <span>മലയാളം</span>
                      </div>
                      <div className="text-end verified">
                        <span style={{ color: "green", fontSize: 14, display: "flex" }}> {data.Malayalam_Value_verified == true ? <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#008000" viewBox="0 0 256 256">
                            <path d="M224.42,104.2c-3.9-4.07-7.93-8.27-9.55-12.18-1.5-3.63-1.58-9-1.67-14.68-.14-9.38-.3-20-7.42-27.12S188,42.94,178.66,42.8c-5.68-.09-11-.17-14.68-1.67-3.91-1.62-8.11-5.65-12.18-9.55C145.16,25.22,137.64,18,128,18s-17.16,7.22-23.8,13.58c-4.07,3.9-8.27,7.93-12.18,9.55-3.63,1.5-9,1.58-14.68,1.67-9.38.14-20,.3-27.12,7.42S42.94,68,42.8,77.34c-.09,5.68-.17,11-1.67,14.68-1.62,3.91-5.65,8.11-9.55,12.18C25.22,110.84,18,118.36,18,128s7.22,17.16,13.58,23.8c3.9,4.07,7.93,8.27,9.55,12.18,1.5,3.63,1.58,9,1.67,14.68.14,9.38.3,20,7.42,27.12S68,213.06,77.34,213.2c5.68.09,11,.17,14.68,1.67,3.91,1.62,8.11,5.65,12.18,9.55C110.84,230.78,118.36,238,128,238s17.16-7.22,23.8-13.58c4.07-3.9,8.27-7.93,12.18-9.55,3.63-1.5,9-1.58,14.68-1.67,9.38-.14,20-.3,27.12-7.42s7.28-17.74,7.42-27.12c.09-5.68.17-11,1.67-14.68,1.62-3.91,5.65-8.11,9.55-12.18C230.78,145.16,238,137.64,238,128S230.78,110.84,224.42,104.2Zm-8.66,39.3c-4.67,4.86-9.5,9.9-12,15.9-2.38,5.74-2.48,12.52-2.58,19.08-.11,7.44-.23,15.14-3.9,18.82s-11.38,3.79-18.82,3.9c-6.56.1-13.34.2-19.08,2.58-6,2.48-11,7.31-15.91,12-5.25,5-10.68,10.24-15.49,10.24s-10.24-5.21-15.5-10.24c-4.86-4.67-9.9-9.5-15.9-12-5.74-2.38-12.52-2.48-19.08-2.58-7.44-.11-15.14-.23-18.82-3.9s-3.79-11.38-3.9-18.82c-.1-6.56-.2-13.34-2.58-19.08-2.48-6-7.31-11-12-15.91C35.21,138.24,30,132.81,30,128s5.21-10.24,10.24-15.5c4.67-4.86,9.5-9.9,12-15.9,2.38-5.74,2.48-12.52,2.58-19.08.11-7.44.23-15.14,3.9-18.82s11.38-3.79,18.82-3.9c6.56-.1,13.34-.2,19.08-2.58,6-2.48,11-7.31,15.91-12C117.76,35.21,123.19,30,128,30s10.24,5.21,15.5,10.24c4.86,4.67,9.9,9.5,15.9,12,5.74,2.38,12.52,2.48,19.08,2.58,7.44.11,15.14.23,18.82,3.9s3.79,11.38,3.9,18.82c.1,6.56.2,13.34,2.58,19.08,2.48,6,7.31,11,12,15.91,5,5.25,10.24,10.68,10.24,15.49S220.79,138.24,215.76,143.5ZM172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76Z">
                            </path>
                          </svg>
                          <p>Verified by law professional</p></> : ""}
                        </span>
                      </div>
                      <button className="feedbackSpn h-auto w-auto" style={{ height: 38 }} onClick={() => HandleEditButton('ml-IN')} >
                        Edit Record
                      </button>
                      <div className="srchOneRgt">
                        <h4 className="srchFrHdng">
                          <strong>{data?.Malayalam_Value}</strong>
                          <div className='speekers'>
                            {data?.Malayalam_Value ? <>
                              <SpeakerHigh size={20} onClick={(e) => { handlePlay(data?.Malayalam_Value, 'ml-IN') }} className="w-auto mr-3" />
                            </> : <></>}
                          </div>
                        </h4>
                      </div>
                    </div>
                    <div className="newtext">
                      <h3>
                        {actView(inputList[0].Act, 'Malayalam_Meaning', "ml-IN")}
                      </h3>
                      <h5>Keywords : {data.Malayalam_Value_keywords.join(', ')}</h5>
                    </div>
                  </div>
                </div>
              </> : <></>}

              {selectLang !== 'mr-IN' ? <>
                <div className="srchListOne _l3">
                  <div className="srchOntBtm">
                    <div className="srchOneTp">
                      <div className="srchOneTpIcn">
                        <span>मराठी</span>
                      </div>
                      <div className="text-end verified">
                        <span style={{ color: "green", fontSize: 14, display: "flex" }}> {data.Marathi_Value_verified == true ? <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#008000" viewBox="0 0 256 256">
                            <path d="M224.42,104.2c-3.9-4.07-7.93-8.27-9.55-12.18-1.5-3.63-1.58-9-1.67-14.68-.14-9.38-.3-20-7.42-27.12S188,42.94,178.66,42.8c-5.68-.09-11-.17-14.68-1.67-3.91-1.62-8.11-5.65-12.18-9.55C145.16,25.22,137.64,18,128,18s-17.16,7.22-23.8,13.58c-4.07,3.9-8.27,7.93-12.18,9.55-3.63,1.5-9,1.58-14.68,1.67-9.38.14-20,.3-27.12,7.42S42.94,68,42.8,77.34c-.09,5.68-.17,11-1.67,14.68-1.62,3.91-5.65,8.11-9.55,12.18C25.22,110.84,18,118.36,18,128s7.22,17.16,13.58,23.8c3.9,4.07,7.93,8.27,9.55,12.18,1.5,3.63,1.58,9,1.67,14.68.14,9.38.3,20,7.42,27.12S68,213.06,77.34,213.2c5.68.09,11,.17,14.68,1.67,3.91,1.62,8.11,5.65,12.18,9.55C110.84,230.78,118.36,238,128,238s17.16-7.22,23.8-13.58c4.07-3.9,8.27-7.93,12.18-9.55,3.63-1.5,9-1.58,14.68-1.67,9.38-.14,20-.3,27.12-7.42s7.28-17.74,7.42-27.12c.09-5.68.17-11,1.67-14.68,1.62-3.91,5.65-8.11,9.55-12.18C230.78,145.16,238,137.64,238,128S230.78,110.84,224.42,104.2Zm-8.66,39.3c-4.67,4.86-9.5,9.9-12,15.9-2.38,5.74-2.48,12.52-2.58,19.08-.11,7.44-.23,15.14-3.9,18.82s-11.38,3.79-18.82,3.9c-6.56.1-13.34.2-19.08,2.58-6,2.48-11,7.31-15.91,12-5.25,5-10.68,10.24-15.49,10.24s-10.24-5.21-15.5-10.24c-4.86-4.67-9.9-9.5-15.9-12-5.74-2.38-12.52-2.48-19.08-2.58-7.44-.11-15.14-.23-18.82-3.9s-3.79-11.38-3.9-18.82c-.1-6.56-.2-13.34-2.58-19.08-2.48-6-7.31-11-12-15.91C35.21,138.24,30,132.81,30,128s5.21-10.24,10.24-15.5c4.67-4.86,9.5-9.9,12-15.9,2.38-5.74,2.48-12.52,2.58-19.08.11-7.44.23-15.14,3.9-18.82s11.38-3.79,18.82-3.9c6.56-.1,13.34-.2,19.08-2.58,6-2.48,11-7.31,15.91-12C117.76,35.21,123.19,30,128,30s10.24,5.21,15.5,10.24c4.86,4.67,9.9,9.5,15.9,12,5.74,2.38,12.52,2.48,19.08,2.58,7.44.11,15.14.23,18.82,3.9s3.79,11.38,3.9,18.82c.1,6.56.2,13.34,2.58,19.08,2.48,6,7.31,11,12,15.91,5,5.25,10.24,10.68,10.24,15.49S220.79,138.24,215.76,143.5ZM172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76Z">
                            </path>
                          </svg>
                          <p>Verified by law professional</p></> : ""}
                        </span>
                      </div>
                      <button className="feedbackSpn h-auto w-auto" style={{ height: 38 }} onClick={() => HandleEditButton('mr-IN')} >
                        Edit Record
                      </button>
                      <div className="srchOneRgt">
                        <h4 className="srchFrHdng">
                          <strong> {data?.Marathi_Value}</strong>
                          <div className='speekers'>
                            {data?.Marathi_Value ? <>
                              <SpeakerHigh size={20} onClick={(e) => { handlePlay(data?.Marathi_Value, 'mr-IN') }} className="w-auto mr-3" />
                            </> : <></>}
                          </div>
                        </h4>
                      </div>
                    </div>
                    <div className="newtext">
                      <h3>
                        {actView(inputList[0].Act, 'Marathi_Meaning', "mr-IN")}
                      </h3>
                      <h5>Keywords : {data.Marathi_Value_keywords.join(', ')}</h5>
                    </div>
                  </div>
                </div>
              </> : <></>}
              {selectLang !== 'gu-IN' ? <>
                <div className="srchListOne _l2">
                  <div className="srchOntBtm">
                    <div className="srchOneTp">
                      <div className="srchOneTpIcn">
                        <span>ગુજરાતી</span>
                      </div>
                      <div className="text-end verified">
                        <span style={{ color: "green", fontSize: 14, display: "flex" }}> {data.Gujarati_Value_verified == true ? <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#008000" viewBox="0 0 256 256">
                            <path d="M224.42,104.2c-3.9-4.07-7.93-8.27-9.55-12.18-1.5-3.63-1.58-9-1.67-14.68-.14-9.38-.3-20-7.42-27.12S188,42.94,178.66,42.8c-5.68-.09-11-.17-14.68-1.67-3.91-1.62-8.11-5.65-12.18-9.55C145.16,25.22,137.64,18,128,18s-17.16,7.22-23.8,13.58c-4.07,3.9-8.27,7.93-12.18,9.55-3.63,1.5-9,1.58-14.68,1.67-9.38.14-20,.3-27.12,7.42S42.94,68,42.8,77.34c-.09,5.68-.17,11-1.67,14.68-1.62,3.91-5.65,8.11-9.55,12.18C25.22,110.84,18,118.36,18,128s7.22,17.16,13.58,23.8c3.9,4.07,7.93,8.27,9.55,12.18,1.5,3.63,1.58,9,1.67,14.68.14,9.38.3,20,7.42,27.12S68,213.06,77.34,213.2c5.68.09,11,.17,14.68,1.67,3.91,1.62,8.11,5.65,12.18,9.55C110.84,230.78,118.36,238,128,238s17.16-7.22,23.8-13.58c4.07-3.9,8.27-7.93,12.18-9.55,3.63-1.5,9-1.58,14.68-1.67,9.38-.14,20-.3,27.12-7.42s7.28-17.74,7.42-27.12c.09-5.68.17-11,1.67-14.68,1.62-3.91,5.65-8.11,9.55-12.18C230.78,145.16,238,137.64,238,128S230.78,110.84,224.42,104.2Zm-8.66,39.3c-4.67,4.86-9.5,9.9-12,15.9-2.38,5.74-2.48,12.52-2.58,19.08-.11,7.44-.23,15.14-3.9,18.82s-11.38,3.79-18.82,3.9c-6.56.1-13.34.2-19.08,2.58-6,2.48-11,7.31-15.91,12-5.25,5-10.68,10.24-15.49,10.24s-10.24-5.21-15.5-10.24c-4.86-4.67-9.9-9.5-15.9-12-5.74-2.38-12.52-2.48-19.08-2.58-7.44-.11-15.14-.23-18.82-3.9s-3.79-11.38-3.9-18.82c-.1-6.56-.2-13.34-2.58-19.08-2.48-6-7.31-11-12-15.91C35.21,138.24,30,132.81,30,128s5.21-10.24,10.24-15.5c4.67-4.86,9.5-9.9,12-15.9,2.38-5.74,2.48-12.52,2.58-19.08.11-7.44.23-15.14,3.9-18.82s11.38-3.79,18.82-3.9c6.56-.1,13.34-.2,19.08-2.58,6-2.48,11-7.31,15.91-12C117.76,35.21,123.19,30,128,30s10.24,5.21,15.5,10.24c4.86,4.67,9.9,9.5,15.9,12,5.74,2.38,12.52,2.48,19.08,2.58,7.44.11,15.14.23,18.82,3.9s3.79,11.38,3.9,18.82c.1,6.56.2,13.34,2.58,19.08,2.48,6,7.31,11,12,15.91,5,5.25,10.24,10.68,10.24,15.49S220.79,138.24,215.76,143.5ZM172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76Z">
                            </path>
                          </svg>
                          <p>Verified by law professional</p></> : ""}
                        </span>
                      </div>
                      <button className="feedbackSpn h-auto w-auto" style={{ height: 38 }} onClick={() => HandleEditButton('gu-IN')} >
                        Edit Record
                      </button>
                      <div className="srchOneRgt">
                        <h4 className="srchFrHdng">
                          <strong>{data?.Gujarati_Value}</strong>
                          <div className='speekers'>
                            {data?.Gujarati_Value ? <>
                              <SpeakerHigh size={20} onClick={(e) => { handlePlay(data?.Gujarati_Value, 'gu-IN') }} className="w-auto mr-3" />
                            </> : <></>}
                          </div>
                        </h4>
                      </div>
                    </div>
                    <div className="newtext">
                      <h3>
                        {actView(inputList[0].Act, 'Gujarati_Meaning', "gu-IN")}
                      </h3>
                      <h5>Keywords : {data.Gujarati_Value_keywords.join(', ')}</h5>
                    </div>
                  </div>
                </div>
              </> : <></>}

              {selectLang !== 'bn-IN' ? <>
                <div className="srchListOne _l1">
                  <div className="srchOntBtm">
                    <div className="srchOneTp">
                      <div className="srchOneTpIcn">
                        <span>বাঙ্গালি</span>
                      </div>
                      <div className="text-end verified">
                        <span style={{ color: "green", fontSize: 14, display: "flex" }}> {data.Bengali_Value_verified == true ? <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#008000" viewBox="0 0 256 256">
                            <path d="M224.42,104.2c-3.9-4.07-7.93-8.27-9.55-12.18-1.5-3.63-1.58-9-1.67-14.68-.14-9.38-.3-20-7.42-27.12S188,42.94,178.66,42.8c-5.68-.09-11-.17-14.68-1.67-3.91-1.62-8.11-5.65-12.18-9.55C145.16,25.22,137.64,18,128,18s-17.16,7.22-23.8,13.58c-4.07,3.9-8.27,7.93-12.18,9.55-3.63,1.5-9,1.58-14.68,1.67-9.38.14-20,.3-27.12,7.42S42.94,68,42.8,77.34c-.09,5.68-.17,11-1.67,14.68-1.62,3.91-5.65,8.11-9.55,12.18C25.22,110.84,18,118.36,18,128s7.22,17.16,13.58,23.8c3.9,4.07,7.93,8.27,9.55,12.18,1.5,3.63,1.58,9,1.67,14.68.14,9.38.3,20,7.42,27.12S68,213.06,77.34,213.2c5.68.09,11,.17,14.68,1.67,3.91,1.62,8.11,5.65,12.18,9.55C110.84,230.78,118.36,238,128,238s17.16-7.22,23.8-13.58c4.07-3.9,8.27-7.93,12.18-9.55,3.63-1.5,9-1.58,14.68-1.67,9.38-.14,20-.3,27.12-7.42s7.28-17.74,7.42-27.12c.09-5.68.17-11,1.67-14.68,1.62-3.91,5.65-8.11,9.55-12.18C230.78,145.16,238,137.64,238,128S230.78,110.84,224.42,104.2Zm-8.66,39.3c-4.67,4.86-9.5,9.9-12,15.9-2.38,5.74-2.48,12.52-2.58,19.08-.11,7.44-.23,15.14-3.9,18.82s-11.38,3.79-18.82,3.9c-6.56.1-13.34.2-19.08,2.58-6,2.48-11,7.31-15.91,12-5.25,5-10.68,10.24-15.49,10.24s-10.24-5.21-15.5-10.24c-4.86-4.67-9.9-9.5-15.9-12-5.74-2.38-12.52-2.48-19.08-2.58-7.44-.11-15.14-.23-18.82-3.9s-3.79-11.38-3.9-18.82c-.1-6.56-.2-13.34-2.58-19.08-2.48-6-7.31-11-12-15.91C35.21,138.24,30,132.81,30,128s5.21-10.24,10.24-15.5c4.67-4.86,9.5-9.9,12-15.9,2.38-5.74,2.48-12.52,2.58-19.08.11-7.44.23-15.14,3.9-18.82s11.38-3.79,18.82-3.9c6.56-.1,13.34-.2,19.08-2.58,6-2.48,11-7.31,15.91-12C117.76,35.21,123.19,30,128,30s10.24,5.21,15.5,10.24c4.86,4.67,9.9,9.5,15.9,12,5.74,2.38,12.52,2.48,19.08,2.58,7.44.11,15.14.23,18.82,3.9s3.79,11.38,3.9,18.82c.1,6.56.2,13.34,2.58,19.08,2.48,6,7.31,11,12,15.91,5,5.25,10.24,10.68,10.24,15.49S220.79,138.24,215.76,143.5ZM172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76Z">
                            </path>
                          </svg>
                          <p>Verified by law professional</p></> : ""}
                        </span>
                      </div>
                      <button className="feedbackSpn h-auto w-auto" style={{ height: 38 }} onClick={() => HandleEditButton('bn-IN')} >
                        Edit Record
                      </button>
                      <div className="srchOneRgt">
                        <h4 className="srchFrHdng">
                          <strong>{data?.Bengali_Value}</strong>
                          <div className='speekers'>
                            {data?.Bengali_Value ? <>
                              <SpeakerHigh size={20} onClick={(e) => { handlePlay(data?.Bengali_Value, 'bn-IN') }} className="w-auto mr-3" />
                            </> : <></>}
                          </div>
                        </h4>
                      </div>
                    </div>
                    <div className="newtext">
                      <h3>
                        {actView(inputList[0].Act, 'Bengali_Meaning', "bn-IN")}
                      </h3>
                      <h5>Keywords : {data.Bengali_Value_keywords.join(', ')}</h5>
                    </div>
                  </div>
                </div>
              </> : <></>}

              {selectLang !== 'pa-IN' ? <>
                <div className="srchListOne _l3">
                  <div className="srchOntBtm">
                    <div className="srchOneTp">
                      <div className="srchOneTpIcn">
                        <span>ਪੰਜਾਬੀ</span>
                      </div>
                      <div className="text-end verified">
                        <span style={{ color: "green", fontSize: 14, display: "flex" }}> {data.Punjabi_Value_verified == true ? <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#008000" viewBox="0 0 256 256">
                            <path d="M224.42,104.2c-3.9-4.07-7.93-8.27-9.55-12.18-1.5-3.63-1.58-9-1.67-14.68-.14-9.38-.3-20-7.42-27.12S188,42.94,178.66,42.8c-5.68-.09-11-.17-14.68-1.67-3.91-1.62-8.11-5.65-12.18-9.55C145.16,25.22,137.64,18,128,18s-17.16,7.22-23.8,13.58c-4.07,3.9-8.27,7.93-12.18,9.55-3.63,1.5-9,1.58-14.68,1.67-9.38.14-20,.3-27.12,7.42S42.94,68,42.8,77.34c-.09,5.68-.17,11-1.67,14.68-1.62,3.91-5.65,8.11-9.55,12.18C25.22,110.84,18,118.36,18,128s7.22,17.16,13.58,23.8c3.9,4.07,7.93,8.27,9.55,12.18,1.5,3.63,1.58,9,1.67,14.68.14,9.38.3,20,7.42,27.12S68,213.06,77.34,213.2c5.68.09,11,.17,14.68,1.67,3.91,1.62,8.11,5.65,12.18,9.55C110.84,230.78,118.36,238,128,238s17.16-7.22,23.8-13.58c4.07-3.9,8.27-7.93,12.18-9.55,3.63-1.5,9-1.58,14.68-1.67,9.38-.14,20-.3,27.12-7.42s7.28-17.74,7.42-27.12c.09-5.68.17-11,1.67-14.68,1.62-3.91,5.65-8.11,9.55-12.18C230.78,145.16,238,137.64,238,128S230.78,110.84,224.42,104.2Zm-8.66,39.3c-4.67,4.86-9.5,9.9-12,15.9-2.38,5.74-2.48,12.52-2.58,19.08-.11,7.44-.23,15.14-3.9,18.82s-11.38,3.79-18.82,3.9c-6.56.1-13.34.2-19.08,2.58-6,2.48-11,7.31-15.91,12-5.25,5-10.68,10.24-15.49,10.24s-10.24-5.21-15.5-10.24c-4.86-4.67-9.9-9.5-15.9-12-5.74-2.38-12.52-2.48-19.08-2.58-7.44-.11-15.14-.23-18.82-3.9s-3.79-11.38-3.9-18.82c-.1-6.56-.2-13.34-2.58-19.08-2.48-6-7.31-11-12-15.91C35.21,138.24,30,132.81,30,128s5.21-10.24,10.24-15.5c4.67-4.86,9.5-9.9,12-15.9,2.38-5.74,2.48-12.52,2.58-19.08.11-7.44.23-15.14,3.9-18.82s11.38-3.79,18.82-3.9c6.56-.1,13.34-.2,19.08-2.58,6-2.48,11-7.31,15.91-12C117.76,35.21,123.19,30,128,30s10.24,5.21,15.5,10.24c4.86,4.67,9.9,9.5,15.9,12,5.74,2.38,12.52,2.48,19.08,2.58,7.44.11,15.14.23,18.82,3.9s3.79,11.38,3.9,18.82c.1,6.56.2,13.34,2.58,19.08,2.48,6,7.31,11,12,15.91,5,5.25,10.24,10.68,10.24,15.49S220.79,138.24,215.76,143.5ZM172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76Z">
                            </path>
                          </svg>
                          <p>Verified by law professional</p></> : ""}
                        </span>
                      </div>
                      <button className="feedbackSpn h-auto w-auto" style={{ height: 38 }} onClick={() => HandleEditButton('pa-IN')} >
                        Edit Record
                      </button>
                      <div className="srchOneRgt">
                        <h4 className="srchFrHdng">
                          <strong> {data?.Punjabi_Value}</strong>
                          <div className='speekers'>
                            {data?.Punjabi_Value ? <>
                              <SpeakerHigh size={20} onClick={(e) => { handlePlay(data?.Punjabi_Value, 'pa-IN') }} className="w-auto mr-3" />
                            </> : <></>}
                          </div>
                        </h4>
                      </div>
                    </div>
                    <div className="newtext">
                      <h3>
                        {actView(inputList[0].Act, 'Punjabi_Meaning', "pa-IN")}
                      </h3>
                      <h5>Keywords : {data.Punjabi_Value_keywords.join(', ')}</h5>
                    </div>
                  </div>
                </div>
              </> : <></>}

              {selectLang !== 'as-IN' ? <>
                <div className="srchListOne _l2">
                  <div className="srchOntBtm">
                    <div className="srchOneTp">
                      <div className="srchOneTpIcn">
                        <span>অসমীয়া</span>
                      </div>
                      <div className="text-end verified">
                        <span style={{ color: "green", fontSize: 14, display: "flex" }}> {data.Assamese_Value_verified == true ? <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#008000" viewBox="0 0 256 256">
                            <path d="M224.42,104.2c-3.9-4.07-7.93-8.27-9.55-12.18-1.5-3.63-1.58-9-1.67-14.68-.14-9.38-.3-20-7.42-27.12S188,42.94,178.66,42.8c-5.68-.09-11-.17-14.68-1.67-3.91-1.62-8.11-5.65-12.18-9.55C145.16,25.22,137.64,18,128,18s-17.16,7.22-23.8,13.58c-4.07,3.9-8.27,7.93-12.18,9.55-3.63,1.5-9,1.58-14.68,1.67-9.38.14-20,.3-27.12,7.42S42.94,68,42.8,77.34c-.09,5.68-.17,11-1.67,14.68-1.62,3.91-5.65,8.11-9.55,12.18C25.22,110.84,18,118.36,18,128s7.22,17.16,13.58,23.8c3.9,4.07,7.93,8.27,9.55,12.18,1.5,3.63,1.58,9,1.67,14.68.14,9.38.3,20,7.42,27.12S68,213.06,77.34,213.2c5.68.09,11,.17,14.68,1.67,3.91,1.62,8.11,5.65,12.18,9.55C110.84,230.78,118.36,238,128,238s17.16-7.22,23.8-13.58c4.07-3.9,8.27-7.93,12.18-9.55,3.63-1.5,9-1.58,14.68-1.67,9.38-.14,20-.3,27.12-7.42s7.28-17.74,7.42-27.12c.09-5.68.17-11,1.67-14.68,1.62-3.91,5.65-8.11,9.55-12.18C230.78,145.16,238,137.64,238,128S230.78,110.84,224.42,104.2Zm-8.66,39.3c-4.67,4.86-9.5,9.9-12,15.9-2.38,5.74-2.48,12.52-2.58,19.08-.11,7.44-.23,15.14-3.9,18.82s-11.38,3.79-18.82,3.9c-6.56.1-13.34.2-19.08,2.58-6,2.48-11,7.31-15.91,12-5.25,5-10.68,10.24-15.49,10.24s-10.24-5.21-15.5-10.24c-4.86-4.67-9.9-9.5-15.9-12-5.74-2.38-12.52-2.48-19.08-2.58-7.44-.11-15.14-.23-18.82-3.9s-3.79-11.38-3.9-18.82c-.1-6.56-.2-13.34-2.58-19.08-2.48-6-7.31-11-12-15.91C35.21,138.24,30,132.81,30,128s5.21-10.24,10.24-15.5c4.67-4.86,9.5-9.9,12-15.9,2.38-5.74,2.48-12.52,2.58-19.08.11-7.44.23-15.14,3.9-18.82s11.38-3.79,18.82-3.9c6.56-.1,13.34-.2,19.08-2.58,6-2.48,11-7.31,15.91-12C117.76,35.21,123.19,30,128,30s10.24,5.21,15.5,10.24c4.86,4.67,9.9,9.5,15.9,12,5.74,2.38,12.52,2.48,19.08,2.58,7.44.11,15.14.23,18.82,3.9s3.79,11.38,3.9,18.82c.1,6.56.2,13.34,2.58,19.08,2.48,6,7.31,11,12,15.91,5,5.25,10.24,10.68,10.24,15.49S220.79,138.24,215.76,143.5ZM172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76Z">
                            </path>
                          </svg>
                          <p>Verified by law professional</p></> : ""}
                        </span>
                      </div>
                      <button className="feedbackSpn h-auto w-auto" style={{ height: 38 }} onClick={() => HandleEditButton('as-IN')} >
                        Edit Record
                      </button>
                      <div className="srchOneRgt">
                        <h4 className="srchFrHdng">
                          <strong>{data?.Assamese_Value}</strong>
                          <div className='speekers'>
                            {data?.Assamese_Value ? <>
                              <SpeakerHigh size={20} onClick={(e) => { handlePlay(data?.Assamese_Value, 'as-IN') }} className="w-auto mr-3" />
                            </> : <></>}
                          </div>
                        </h4>
                      </div>
                    </div>
                    <div className="newtext">
                      <h3>
                        {actView(inputList[0].Act, 'Assamese_Meaning', "as-IN")}
                      </h3>
                      <h5>Keywords : {data.Assamese_Value_keywords.join(', ')}</h5>
                    </div>
                  </div>
                </div>
              </> : <></>}

              {selectLang !== 'or-IN' ? <>
                <div className="srchListOne _l1">
                  <div className="srchOntBtm">
                    <div className="srchOneTp">
                      <div className="srchOneTpIcn">
                        <span>ଓଡ଼ିଆ</span>
                      </div>
                      <div className="text-end verified">
                        <span style={{ color: "green", fontSize: 14, display: "flex" }}> {data.Oriya_Value_verified == true ? <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#008000" viewBox="0 0 256 256">
                            <path d="M224.42,104.2c-3.9-4.07-7.93-8.27-9.55-12.18-1.5-3.63-1.58-9-1.67-14.68-.14-9.38-.3-20-7.42-27.12S188,42.94,178.66,42.8c-5.68-.09-11-.17-14.68-1.67-3.91-1.62-8.11-5.65-12.18-9.55C145.16,25.22,137.64,18,128,18s-17.16,7.22-23.8,13.58c-4.07,3.9-8.27,7.93-12.18,9.55-3.63,1.5-9,1.58-14.68,1.67-9.38.14-20,.3-27.12,7.42S42.94,68,42.8,77.34c-.09,5.68-.17,11-1.67,14.68-1.62,3.91-5.65,8.11-9.55,12.18C25.22,110.84,18,118.36,18,128s7.22,17.16,13.58,23.8c3.9,4.07,7.93,8.27,9.55,12.18,1.5,3.63,1.58,9,1.67,14.68.14,9.38.3,20,7.42,27.12S68,213.06,77.34,213.2c5.68.09,11,.17,14.68,1.67,3.91,1.62,8.11,5.65,12.18,9.55C110.84,230.78,118.36,238,128,238s17.16-7.22,23.8-13.58c4.07-3.9,8.27-7.93,12.18-9.55,3.63-1.5,9-1.58,14.68-1.67,9.38-.14,20-.3,27.12-7.42s7.28-17.74,7.42-27.12c.09-5.68.17-11,1.67-14.68,1.62-3.91,5.65-8.11,9.55-12.18C230.78,145.16,238,137.64,238,128S230.78,110.84,224.42,104.2Zm-8.66,39.3c-4.67,4.86-9.5,9.9-12,15.9-2.38,5.74-2.48,12.52-2.58,19.08-.11,7.44-.23,15.14-3.9,18.82s-11.38,3.79-18.82,3.9c-6.56.1-13.34.2-19.08,2.58-6,2.48-11,7.31-15.91,12-5.25,5-10.68,10.24-15.49,10.24s-10.24-5.21-15.5-10.24c-4.86-4.67-9.9-9.5-15.9-12-5.74-2.38-12.52-2.48-19.08-2.58-7.44-.11-15.14-.23-18.82-3.9s-3.79-11.38-3.9-18.82c-.1-6.56-.2-13.34-2.58-19.08-2.48-6-7.31-11-12-15.91C35.21,138.24,30,132.81,30,128s5.21-10.24,10.24-15.5c4.67-4.86,9.5-9.9,12-15.9,2.38-5.74,2.48-12.52,2.58-19.08.11-7.44.23-15.14,3.9-18.82s11.38-3.79,18.82-3.9c6.56-.1,13.34-.2,19.08-2.58,6-2.48,11-7.31,15.91-12C117.76,35.21,123.19,30,128,30s10.24,5.21,15.5,10.24c4.86,4.67,9.9,9.5,15.9,12,5.74,2.38,12.52,2.48,19.08,2.58,7.44.11,15.14.23,18.82,3.9s3.79,11.38,3.9,18.82c.1,6.56.2,13.34,2.58,19.08,2.48,6,7.31,11,12,15.91,5,5.25,10.24,10.68,10.24,15.49S220.79,138.24,215.76,143.5ZM172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76Z">
                            </path>
                          </svg>
                          <p>Verified by law professional</p></> : ""}
                        </span>
                      </div>
                      <button className="feedbackSpn h-auto w-auto" style={{ height: 38 }} onClick={() => HandleEditButton('or-IN')} >
                        Edit Record
                      </button>
                      <div className="srchOneRgt">
                        <h4 className="srchFrHdng">
                          <strong>{data?.Oriya_Value}</strong>
                          <div className='speekers'>
                            {data?.Oriya_Value ? <>
                              <SpeakerHigh size={20} onClick={(e) => { handlePlay(data?.Oriya_Value, 'or-IN') }} className="w-auto mr-3" />
                            </> : <></>}
                          </div>
                        </h4>
                      </div>
                    </div>
                    <div className="newtext">
                      <h3>
                        {actView(inputList[0].Act, 'Oriya_Meaning', "or-IN")}
                      </h3>
                      <h5>Keywords : {data.Oriya_Value_keywords.join(', ')}</h5>
                    </div>
                  </div>
                </div>
              </> : <></>}

            </div>
          </section>
          :
          <>
            <div className="container pt-5" style={{ display: "grid" }}>
              Related Keywords :
              <div className=" btnGroup d-flex justify-content-start flex-wrap">

                <section className="searchListSec">
                  {isLoading === true ? <>
                    <div className='text-center'>
                      <Placeholder.Paragraph rows={8} />
                      <Loader backdrop content="loading..." vertical />
                    </div>
                  </> : <>

                    {searchKeys.map(it => (
                      <>
                        {it[JasonFile[1][selectLang]] ?
                          <><button style={{ width: "23%", height: "auto", padding: 5 }} onClick={() => {
                            keySelected(it);
                            localStorage.setItem("legalsearchQuery", it[JasonFile[1][selectLang]]);
                          }}>{it[JasonFile[1][selectLang]]}</button></> : <></>}
                      </>
                    ))}
                  </>}
                </section>
              </div>
            </div>
          </>}
      </div>
    </>
  );
}


export default ListPage;
